exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shipping-options[data-v-0538e0b3] {\n  display: grid;\n  gap: var(--size-lg);\n}\n.shipping-options__skeleton[data-v-0538e0b3] {\n  display: grid;\n  gap: var(--size-md);\n  grid-template-columns: var(--size-md) 1fr 60px;\n  padding: var(--size-md);\n}\n.shipping-options__skeleton > span[data-v-0538e0b3] {\n  border-radius: var(--size-sm);\n  height: var(--size-lg);\n  background: var(--gray-300);\n}\n.shipping-options__skeleton > span[data-v-0538e0b3]:nth-child(1) {\n  width: var(--size-lg);\n  height: var(--size-lg);\n  border-radius: var(--size-lg);\n}", ""]);

// exports
